<template>
  <div data-component-group="filter-forms" data-component="banner">
    <FiltersForm
      has-phone-sheet
      :applied-filters="appliedFilters"
      :on-clear-filter="clearFilter"
      :has-filters="hasFilters"
      @filter="onFilter"
      @clear="onClearFilters"
      v-model="selectedCountries"
    >
      <template v-slot:phone-actions>
        <slot name="phone-actions" />
      </template>

      <v-text-field
        clearable
        v-model="search"
        type="search"
        label="Search"
        prepend-inner-icon="search"
      />

      <base-date-picker
        :date="dates"
        :placeholder="$t('dates_placeholder')"
        :config="dateConfig"
        :on-change="onChangeDate"
      />

      <v-autocomplete
        clearable
        v-model="status"
        :items="statuses"
        prepend-inner-icon="download_done"
        item-title="name"
        item-value="id"
        :label="$t('status')"
      />
    </FiltersForm>
  </div>
</template>

<script>
  import FiltersForm from './FiltersBase';
  import filterUrlSync from '@/mixins/filterUrlSync';
  import filterChips, { platformChips } from '@/mixins/filterChips';
  import { escapeSearch } from '@/utils'

  // TODO: Translate component

  export default {
    mixins: [filterUrlSync, filterChips],
    components: {
      FiltersForm,
    },
    emits: ['clearFilters', 'filter'],
    data() {
      return {
        urlConfig: [
          { field: 'search', urlKey: 'search', type: 'string' },
          { field: 'status', urlKey: 'status', type: 'number', fetchMethod: 'getStatuses' },
          { field: 'dates', urlKey: 'dates', type: 'string' },
          { field: 'selectedCountries', urlKey: 'countries', type: 'string[]' },
        ],
        search: null,
        dates: null,
        status: null,
        dateConfig: {
          mode: 'range',
        },
        selectedCountries: []
      };
    },
    created() {
      this.getStatuses();
    },
    computed: {
      hasFilters() {
        const {
          search,
          dates,
          status,
          selectedCountries
        } = this;

        return !!search ||
          !!dates ||
          status !== null ||
          selectedCountries.length > 0;
      },
      statuses() {
        return this.$store.getters['siteMessages/statuses'];
      },
      filterChipFields() {
        const platforms = this.$store.getters['users/countries'] || [];

        return [
          {
            model: 'selectedCountries',
            label: this.$t('platform'),
            toChips: platformChips(platforms),
          },
          { model: 'search', label: 'Search' },
          { model: 'dates', label: this.$t('dates_placeholder') },
          {
            model: 'status',
            label: this.$t('status'),
            toChips: (status) => [{
              value: this.statuses.find(({ id }) => id === status)?.name ?? status,
            }],
          },
        ];
      },
    },
    methods: {
      onChangeDate(dates) {
        this.dates = dates;
      },
      onFilter() {
        const {
          search,
          dates,
          selectedCountries,
          status,
        } = this;
        const formattedSearch = escapeSearch(search);

        this.syncFiltersToUrl();
        this.rememberAppliedFilters();


        this.$emit('filter', {
          search: formattedSearch,
          dates,
          countries: selectedCountries,
          status,
        });
      },
      onClearFilters() {
        this.search = null;
        this.dates = null;
        this.selectedCountries = [];
        this.status = null;

        this.clearFiltersUrl();
        this.forgetAppliedFilters();


        this.$emit('clearFilters');
      },
      getStatuses() {
        return this.$store.dispatch('siteMessages/getStatuses');
      },
    },
  };
</script>

<style lang="scss" scoped>
[data-component-group='filter-forms'] {
  &[data-component='banner'] {
    h1 {
      display: flex;
      align-items: center;
      margin: 0 0 32px 0;
      min-height: 48px;
    }
  }
}
</style>
